import React from 'react'
import classNames from 'classnames'
import styles from './index.module.less'

export default ({ style, children, className, onClick }:any) => {
  return <div className={classNames(styles.highlightButton, className)} style={style}>
    <div className="highlightButtonText" onClick={onClick}>
      {children}
      <img className="highlightButtonIcon" src="https://zhiyi-image.oss-cn-hangzhou.aliyuncs.com/web/noviceRecommendationImage01/btnIcon.png" />
    </div>
  </div>
}
